import React from 'react';
import CategoryBase from '../Component/CategoryBase';

const CategoryDeathReason = () => {
  return <CategoryBase baseEndpoint="category_deaths_reason" />;
};

export default CategoryDeathReason;
